import { LayoutGrid, List } from "lucide-react"
import { SegmentedControl } from "@/components/ui/segmented-control"
import { useTranslation } from "@/hooks/use-translation"
import type { LibraryViewMode } from "@/lib/library-view-mode"

type Props = {
  mode: LibraryViewMode
  onChange: (mode: LibraryViewMode) => void
}

export function LibraryViewToggle({ mode, onChange }: Props) {
  const { t } = useTranslation(["workspace"])

  return (
    <SegmentedControl
      className="shrink-0"
      value={mode}
      onChange={(id) => onChange(id as LibraryViewMode)}
      items={[
        {
          id: "grid",
          icon: <LayoutGrid className="h-3.5 w-3.5" />,
          ariaLabel: t("library.view.grid"),
          hint: t("library.view.grid"),
        },
        {
          id: "list",
          icon: <List className="h-3.5 w-3.5" />,
          ariaLabel: t("library.view.list"),
          hint: t("library.view.list"),
        },
      ]}
    />
  )
}
